import React from 'react';
import { useGetAllBranchesDailySalesQuery } from '../generated/graphql';
import { ProgressSpinner } from 'primereact/progressspinner';
import { currencyFormat } from '../helpers/currencyFormat';

const BranchOverview: React.FC = () => {
    const { data, loading, error } = useGetAllBranchesDailySalesQuery({
        fetchPolicy: 'network-only',
    });

    if (loading) {
        return (
            <div className="flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                <ProgressSpinner />
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                <div className="text-red-500">Error loading branch data: {error.message}</div>
            </div>
        );
    }

    const branches = data?.getAllBranchesDailySales || [];

    return (
        <div style={{ 
            padding: window.innerWidth < 768 ? '1rem' : '1.3rem 3rem 3rem 3rem', 
            color: '#f4f4fc' 
        }}>
            <div style={{ marginBottom: window.innerWidth < 768 ? '1rem' : '2rem' }}>
                <h1 style={{ 
                    fontWeight: 100, 
                    fontSize: window.innerWidth < 768 ? '1.5rem' : '1.8rem', 
                    color: '#f4f4fc' 
                }}>Branch Overview</h1>
                <p style={{ 
                    color: '#a0a0a0', 
                    marginTop: '0.5rem',
                    fontSize: window.innerWidth < 768 ? '0.875rem' : '1rem'
                }}>Today's sales across all branches</p>
            </div>

                        <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
                gap: '1rem',
                maxHeight: 'calc(100vh - 200px)',
                overflow: 'auto',
                padding: '0.5rem'
            }}>
                {branches.map((branch) => (
                    <div key={branch.id} style={{
                        background: 'rgba(45, 45, 51, 0.45)',
                        backdropFilter: 'blur(40px)',
                        border: '1px solid rgba(134, 134, 134, 0.4)',
                        borderRadius: '8px',
                        padding: window.innerWidth < 768 ? '1.5rem' : '2rem',
                        textAlign: 'center',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        minHeight: '120px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                    }} onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'rgba(45, 45, 51, 0.6)';
                        e.currentTarget.style.border = '1px solid rgba(134, 134, 134, 0.6)';
                    }} onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'rgba(45, 45, 51, 0.45)';
                        e.currentTarget.style.border = '1px solid rgba(134, 134, 134, 0.4)';
                    }}>
                        <h3 style={{ 
                            fontSize: window.innerWidth < 768 ? '1.2rem' : '1.5rem', 
                            fontWeight: 500, 
                            color: '#f4f4fc', 
                            marginBottom: window.innerWidth < 768 ? '0.5rem' : '1rem' 
                        }}>
                            {branch.name}
                        </h3>
                        <div style={{ 
                            fontSize: window.innerWidth < 768 ? '1.5rem' : '2rem', 
                            fontWeight: 'bold', 
                            color: 'rgb(10, 161, 211)', 
                            marginBottom: window.innerWidth < 768 ? '0.25rem' : '0.5rem' 
                        }}>
                            {currencyFormat(branch.todaySales)}
                        </div>
                        <p style={{ 
                            fontSize: window.innerWidth < 768 ? '0.75rem' : '0.875rem', 
                            color: '#a0a0a0' 
                        }}>
                            Today's Sales
                        </p>
                    </div>
                ))}
            </div>

            {branches.length === 0 && (
                <div style={{ textAlign: 'center', color: '#a0a0a0', marginTop: '2rem' }}>
                    No branches found
                </div>
            )}
        </div>
    );
};

export default BranchOverview; 